import { render, staticRenderFns } from "./ViewDevice.vue?vue&type=template&id=0e60d2b7&"
import script from "./ViewDevice.vue?vue&type=script&lang=ts&"
export * from "./ViewDevice.vue?vue&type=script&lang=ts&"
import style0 from "./ViewDevice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports